// Percorso file: src/pages/legal/MorePage.jsx
//
// IL CONTENITORE «MORE / ASSISTANCE» (rotta /more, cantiere LEGAL-DOCS,
// fetta 2): la pagina di secondo livello che il pulsante in coda alle
// cinque home (ADMIN, SUPERADMIN, PLAYER, PARENT, COACH) apre. È un
// contenitore e nient'altro: quattro voci, più «Logout» in coda (vedi
// sotto), e nessun dato proprio.
//
//   «Legal & Privacy»    → /legal      (documenti `category: "legal"`)
//   «Terms & Conditions» → /terms      (documenti `category: "terms"`)
//   «Member Protection»  → /legal/mpio (la scheda del MPIO, direttamente)
//   «Assistant»          → /assistant  (l'assistente dei soci)
//
// Le prime due rotte montano lo stesso LegalIndex.jsx con categoria e
// titolo diversi. La terza (fetta MPIO, 14/9/2026) NON apre un elenco:
// linka direttamente al visualizzatore del documento, perché la scheda
// del MPIO è una sola (`category: "safety"`, senza indice). La quarta
// (cantiere ASSISTENTE-SOCI, «strada A» del 14/9/2026) è l'assistente:
// stava nelle tre home dei soci (cf1831c), e da qui in poi sta SOLO QUI —
// un bottone solo, senza doppioni. Ne consegue che la vedono anche ADMIN e
// SUPERADMIN, che aprono la stessa /more: è accettato, e per questo NON c'è
// nessuna condizione di ruolo. La voce è CABLATA (`navigate("/assistant")`)
// e ACCESA dal 15/9/2026 (apertura ai soci, dopo il collaudo dell'assistente):
// fino ad allora era spenta con `disabled: true` nella tabella → attributo
// `disabled`, che HomeShell.css attenua e rende non premibile. Il flag resta
// disponibile nella tabella: rimetterlo su una voce la spegne di nuovo.
//
// «Clinics» (→ /clinics, cantiere CLINICS, Fetta C2) è stata qui dal
// 15/9 al 23/9/2026: per decisione del committente l'ingresso dell'area
// clinic del socio è uscito da More ed è entrato nelle home HomePlayer,
// HomeChild e HomeCoach, sopra lo Shop, col nome del bottone admin
// («Clinic / Off Season / Specials»). HomeParent non lo ha: il genitore
// ci arriva dalla HomeChild del figlio.
//
// La forma è quella dei menu delle home (HomeAdmin.jsx: `nav.qpsc-menu` +
// `button.qpsc-btn-gold` con `navigate(to)`, icona Font Awesome a
// sinistra — §5, regola tutto-o-niente) dentro il telaio comune, come
// LegalIndex.jsx. Elenco e pulsanti sono del telaio; l'unica classe
// propria è lo STACCO dell'ultima voce (`spaced`, come il flag omonimo del
// MENU di HomeAdmin.jsx): l'Assistant non è un documento, e i 16px in più
// — `.qpsc-more-spaced`, in legal.css, il CSS di questa cartella — lo
// separano dalle tre voci legali (16 di gap + 16 di margine = 32, il
// doppio respiro §4). Le voci stanno in una tabella, come il MENU delle
// home, con la chiave sull'etichetta.
//
// «Logout» (cantiere LOGOUT-1, 26/9/2026) è l'ULTIMA voce: il Logout ha
// lasciato la barra utente, che lo mostra ormai solo sulle schermate-vicolo
// cieco (vedi UserBar.jsx). È resa A MANO in coda al `nav`, fuori dalla
// tabella VOCI — come «More / Assistance» in coda al menu delle home
// (HomeAdmin.jsx) — perché non naviga: chiama `logout()` di AuthContext,
// lo stesso gestore del Logout della barra, e nient'altro (tolto l'utente,
// il cancello di /more manda al login). Stesso stacco dell'Assistant
// (`.qpsc-more-spaced`), rossa con la variante d'accento dello Shop
// (`.qpsc-btn-gold--accent`, HomeShell.css, §5.1: una sola per pagina, ed
// è questa), icona FaSignOutAlt: il Logout della barra non ne ha una.
//
// Il Back è «da dove si è venuti» (`navigate(-1)`), non `/home`: vedi la
// nota in LegalDocument.jsx. Il controllo d'accesso NON sta qui: sta in
// App.jsx, nel cancello condiviso RequireRole.

import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaBalanceScale,
  FaFileContract,
  FaUserShield,
  FaRobot,
  FaSignOutAlt,
} from "react-icons/fa";
import HomeShell from "../../components/HomeShell";
import { useAuth } from "../../context/AuthContext";
import "./legal.css";

// `spaced: true` è il doppio respiro (`.qpsc-more-spaced`, legal.css);
// `disabled: true` (oggi su nessuna voce) rende una voce spenta: presente,
// cablata, non premibile. L'Assistant è acceso dal 15/9/2026.
const VOCI = [
  { label: "Legal & Privacy", to: "/legal", Icon: FaBalanceScale },
  { label: "Terms & Conditions", to: "/terms", Icon: FaFileContract },
  { label: "Member Protection", to: "/legal/mpio", Icon: FaUserShield },
  { label: "Assistant", to: "/assistant", Icon: FaRobot, spaced: true },
];

const MorePage = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <HomeShell backTo={() => navigate(-1)}>
      <h1 className="qpsc-page-title">More / Assistance</h1>

      <nav className="qpsc-menu">
        {VOCI.map(({ label, to, Icon, spaced, disabled }) => (
          <button
            key={label}
            type="button"
            className={"qpsc-btn-gold" + (spaced ? " qpsc-more-spaced" : "")}
            onClick={() => navigate(to)}
            disabled={disabled}
          >
            <span className="qpsc-btn-gold__icon">
              <Icon />
            </span>
            {label}
          </button>
        ))}

        {/* «Logout», resa a mano in coda: vedi il cappello del file. */}
        <button
          type="button"
          className="qpsc-btn-gold qpsc-btn-gold--accent qpsc-more-spaced"
          onClick={logout}
        >
          <span className="qpsc-btn-gold__icon">
            <FaSignOutAlt />
          </span>
          Logout
        </button>
      </nav>
    </HomeShell>
  );
};

export default MorePage;
